import script from "./PageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=77517f54&scoped=true&lang=scss"

import exportComponent from "E:\\TeamCity\\buildAgent\\work\\44e3aa492d05d81f\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77517f54"]])

export default __exports__